import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import zget from "zget";
import { dispatch, connect } from "../recontext/store";
import { api } from "../services/index";
import Loading from "./Loading";

// bad hacks for waiting init new user
function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

class ProfileDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleClickSubmit = this.handleClickSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.delayInitNewUser = this.delayInitNewUser.bind(this);
    this.state = {
      loading: false,
      displayName: "",
      intro: "",
      lookingFor: ""
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      updateProfileDialogVisible,
      createProfileDialogVisible
    } = this.props;
    if (
      (nextProps.updateProfileDialogVisible && !updateProfileDialogVisible) ||
      (nextProps.createProfileDialogVisible && !createProfileDialogVisible)
    ) {
      this.setState({
        loading: nextProps.createProfileDialogVisible,
        displayName: zget(nextProps, "user.displayName"),
        intro: zget(nextProps, "user.intro"),
        lookingFor: zget(nextProps, "user.lookingFor")
      });
      if (nextProps.createProfileDialogVisible) {
        this.delayInitNewUser();
      }
    }
  }

  handleClose() {
    this.setState({
      loading: false,
      displayName: "",
      intro: "",
      lookingFor: ""
    });
    dispatch("HIDE_PROFILE_DIALOG");
  }

  async delayInitNewUser() {
    await sleep(4000);
    this.setState({ loading: false });
  }

  async handleClickSubmit() {
    this.setState({ loading: true });
    const { user } = this.props;
    const { displayName, intro, lookingFor } = this.state;
    await api.updateMe(user, {
      displayName,
      intro,
      lookingFor
    });
    this.handleClose();
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  render() {
    const {
      user,
      updateProfileDialogVisible,
      createProfileDialogVisible
    } = this.props;
    const { loading, displayName, intro, lookingFor } = this.state;
    const isOpen = updateProfileDialogVisible || createProfileDialogVisible;

    const loadingText = createProfileDialogVisible
      ? "Creating your account, please wait a few seconds"
      : null;

    return (
      <Dialog
        open={isOpen}
        disableBackdropClick={true}
        onClose={this.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Update Profile</DialogTitle>
        <DialogContent>
          <DialogContentText>Please update your information</DialogContentText>
          <TextField
            required
            autoFocus
            disabled
            margin="dense"
            id="email"
            label="Email Address"
            type="email"
            value={zget(user, "email") || ""}
            fullWidth
          />
          <TextField
            autoFocus
            required
            margin="dense"
            id="displayName"
            name="displayName"
            label="Full Name"
            value={displayName || ""}
            onChange={this.handleChange}
            fullWidth
          />
          <TextField
            required
            margin="dense"
            id="intro"
            name="intro"
            label="About me (and skills)"
            value={intro || ""}
            onChange={this.handleChange}
            fullWidth
          />
          <TextField
            required
            margin="dense"
            id="lookingFor"
            name="lookingFor"
            label="Want to match with"
            value={lookingFor || ""}
            onChange={this.handleChange}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          {!createProfileDialogVisible && (
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
          )}
          <Button onClick={this.handleClickSubmit} color="primary">
            Update
          </Button>
        </DialogActions>
        <Loading visible={loading} text={loadingText} />
      </Dialog>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  updateProfileDialogVisible: state.updateProfileDialogVisible,
  createProfileDialogVisible: state.createProfileDialogVisible
});

export default connect(mapStateToProps)(ProfileDialog);
